import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

export const TestConfigContext = createContext();

export const useTestConfig = () => {
  const context = useContext(TestConfigContext);
  if (!context) {
    throw new Error('useTestConfig must be used within TestConfigProvider');
  }
  return context;
};

export const TestConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    token: '',
    productId: '4',
    environmentId: '2',
    countryId: '4',
    language: 'en',
  });

  const updateConfig = useCallback((newConfig) => {
    setConfig((prev) => ({ ...prev, ...newConfig }));
  }, []);

  const contextValue = useMemo(
    () => ({ config, updateConfig }),
    [config, updateConfig]
  );

  return (
    <TestConfigContext.Provider value={contextValue}>
      {children}
    </TestConfigContext.Provider>
  );
};

TestConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

